module.exports = __webpack_public_path__ + "img/ic_notification.2599104a.svg";